var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item){return _c('v-checkbox',{key:item[_vm.valueField],attrs:{"label":item[_vm.labelField],"value":item[_vm.valueField]},on:{"change":_vm.change},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }